import * as React from "react";
const SvgFiRrPenNib = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-nib_svg__a)">
      <path
        fill="#062147"
        d="M23.708 7.293a1 1 0 0 0-1.414 0L20 9.586 14.415 4l2.293-2.293A.999.999 0 1 0 15.294.293l-2.846 2.845-5.863 2.17a5.02 5.02 0 0 0-3.073 3.316l-3.4 11.921a2.69 2.69 0 0 0 .68 2.664 2.69 2.69 0 0 0 2.654.682l11.885-3.377a5.02 5.02 0 0 0 3.314-3.054l2.215-5.907 2.846-2.846a1 1 0 0 0 0-1.414zm-6.935 9.465a3.01 3.01 0 0 1-1.99 1.833l-11.12 3.16 5.818-5.818q.25.067.518.068a2 2 0 1 0-1.932-1.482L2.25 20.336l3.184-11.16a3.01 3.01 0 0 1 1.844-1.992l5.468-2.023 6.09 6.091z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-nib_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenNib;
